import { defineRoutes } from "@/service/routing/schema";

const base = "/wydarzenia";

export const eventsRoutes = defineRoutes({
  "events.index": () => `${base}`,
  "events.show": ({ slug }: { slug: string }) => `${base}/${slug}`,
  /** items w formacie `<variantId>:<ilość>,<variantId>:<ilość>` */
  "events.checkout": ({ slug, items }: { slug: string; items: string }) =>
    `${base}/${slug}/dane?items=${encodeURIComponent(items)}`,
  /** Adres podsumowania zna też backend (urlSuccess w checkoucie ZEN) - zmiana wymaga obu stron. */
  "events.status": () => `${base}/status`,
} as const);
